import React, { Fragment } from 'react'

import Banner from './Banner'
import Content from './Content'

export default function OurCommitmentPage() {
    return (
        <Fragment>
            <Banner />
            <Content />
        </Fragment>
    )
}
